import { IconButton, Popover } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useState } from "react";
import { EllipsisIcon } from "../../../../../assets/icons";

interface Props {
  children: JSX.Element;
}
interface State {
  open: boolean;
  anchorEl: HTMLButtonElement | null;
}
const DataActions = ({ children }: Props) => {
  const theme = useTheme();
  const [state, setState] = useState<State>({
    open: false,
    anchorEl: null,
  });
  return (
    <>
      <IconButton
        onClick={(event) => {
          setState((state) => ({
            ...state,
            open: true,
            anchorEl: event.currentTarget as HTMLButtonElement,
          }));
        }}
        style={{
          color: theme.palette.text.primary,
        }}
      >
        <EllipsisIcon />
      </IconButton>
      <Popover
        open={state.open}
        anchorEl={state.anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        onClose={() => {
          setState((state) => ({ ...state, open: false }));
        }}
        PaperProps={{
          sx: {
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            alignItems: "flex-start",
            gap: "5px",
          },
        }}
      >
        {children}
      </Popover>
    </>
  );
};
export default DataActions;
